import styled, { keyframes } from "styled-components";

import { colorTheme, gridSpacing } from "@utils";

import type { MarginInterface } from "../utilities/interfaces";

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

const getMarginValue = (
  value: number | boolean | undefined,
  defaultValue: number | undefined,
) => {
  if (value === undefined) {
    return defaultValue !== undefined ? `${gridSpacing[defaultValue]}px` : "0";
  }
  if (typeof value === "boolean") {
    return value ? `${gridSpacing[2]}px` : "0";
  }
  return `${gridSpacing[value]}px`;
};

const SkeletonLoader = styled.div<
  MarginInterface & {
    width?: number | string;
    height?: number | string;
  }
>`
  height: ${({ height }) =>
    typeof height === "number" ? `${height}px` : height || "18px"};
  min-height: ${({ height }) =>
    typeof height === "number" ? `${height}px` : height || "18px"};
  max-height: ${({ height }) =>
    typeof height === "number" ? `${height}px` : height || "18px"};
  background-color: ${colorTheme("neutralL4")};
  border-radius: 4px;
  width: ${({ width }) =>
    typeof width === "number" ? `${width}px` : width || "100px"};
  animation: ${pulse} 1.5s infinite ease-in-out;
  margin: ${({ m }) => (m ? `${gridSpacing[m]}px` : "0")};
  margin-left: ${({ ml, mx }) => getMarginValue(ml, mx)};
  margin-right: ${({ mr, mx }) => getMarginValue(mr, mx)};
  margin-top: ${({ mt, my }) => getMarginValue(mt, my)};
  margin-bottom: ${({ mb, my }) => getMarginValue(mb, my)};
`;

export default SkeletonLoader;
